export { default } from './getStylesCreator';